// 开场白模块
import React, {
  useCallback,
  useEffect,
  // useMemo,
  useRef,
  useState,
  memo,
} from 'react';
import { getGuessYourQuestion, getChatMenu } from '@/services/fetchs';
import styles from './index.module.scss';

const questionIconMap = {
  0: 'https://imgcdn.sto.cn/C743A1DD-22CD-48-24x24-79ABCFF4-120C-4DBE-B9B0-D051965250DC.png',
  1: 'https://imgcdn.sto.cn/AFF66601-8005-4F-24x24-327EE8FB-C3FE-4EE9-A5BA-4E968B81EF7F.png',
  2: 'https://imgcdn.sto.cn/8E800CE9-2F6A-4A-24x24-5BE77307-6A7D-49E8-905C-EB5C596AD98A.png',
};
//
const Prologue = ({ onSubmit, setIsLoaded, robotName, sysPrompt, introduction, skillType, ...props }) => {
  const chatMenuBox = useRef<any>(null);
  const [chatMenu, setChatMenu] = useState<any>([]);
  const [quickQuestions, setQuickQuestions] = useState([]);
  const [isFull, setIsFull] = useState(false);
  // const chatMenuBox = useRef<any>();

  // 只在首次挂载时请求
  const getMerchantListQuestionDt = useCallback((skillType) => {
    getGuessYourQuestion({
      sessionId: props.sessionId,
      listSize: 3,
      skillType,
    }).then((res) => {
      setQuickQuestions(res.data);
    });
  }, [props.sessionId]);

  const getChatMenuData = useCallback(() => {
    getChatMenu({ platform: 'WEB', userClient: 'WEB', }).then((res) => {
      const { data } = res;
      setChatMenu(data);
      setIsLoaded && setIsLoaded(true);
    });
  }, [setIsLoaded]);

  const onResizeObserver = useCallback(() => {
    // 获取指定的元素
    const element = chatMenuBox.current;

    // 创建一个 ResizeObserver 实例
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        // 监听到宽度变化时的回调
        const { width } = entry.contentRect;
        setIsFull(width > 500);
      }
    });

    // 开始观察指定的元素
    if (element) {
      resizeObserver.observe(element);
    }

    return () => {
      if (element) {
        resizeObserver.unobserve(element);
      }
      resizeObserver.disconnect();
    };
  }, []);

  // 只在首次挂载时请求"猜你想问"
  useEffect(() => {
    getMerchantListQuestionDt(skillType);
  }, []);
  useEffect(getChatMenuData, [getChatMenuData]);
  useEffect(onResizeObserver, [onResizeObserver]);

  return (
    <div className={styles.chatBoxNew}>
      <div className={styles.chatTopBox}>
        <img
          src="https://imgcdn.sto.cn/882E858F-659B-4D-150x150-%E9%A1%B5%E9%9D%A2%E5%86%85.gif"
          alt="robot"
        />
        <div className={styles.contentBox}>
          <div className={styles.title}>{`Hi，我是${robotName}～`}</div>
          <div className={styles.subTitle}>
            {introduction || '可以给您提供平台功能问答，帮助您更好的了解产品与服务，快来试试吧！'}
          </div>
        </div>
      </div>
      {/* 固定快捷操作模块 */}
      <div
        ref={chatMenuBox}
        className={`${styles.chatMiddleMenuBox} ${isFull ? styles.isFull : ''}`}
      >
        {chatMenu?.map(({ title, icon, funcItemList }, index) => (
          <div
            key={`tour${index}`}
            id={`tour${index}`}
            className={styles.chatMiddleMenuBoxItem}
          >
            <div className={styles.itemTitle}>
              <img src={icon} alt={''} />
              {title}
            </div>
            <div className={styles.buttonsBox}>
              {(funcItemList || [])?.map?.(({ name, question, hotFlag }) => (
                <div
                  key={name}
                  className={styles.buttons}
                  onClick={() => {
                    onSubmit({ content: question.question }, question);
                  }}
                >
                  {name}
                  {hotFlag ? (
                    <img
                      style={{ width: '14px', marginLeft: '6px' }}
                      src="https://imgcdn.sto.cn/C0E7F7F0-2363-43-28x28-fire.png"
                      alt=""
                    />
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {/* 猜你想问模块：第一版样式 */}
      {/* <div className={styles.chatMiddleBox}>
        <div className={styles.chatMiddleBoxTitle}>
          <div className={styles.questionTitle}>猜你想问：</div>
          <img src="https://imgcdn.sto.cn/01A8B7FB-5449-42-19x19-replace.png" alt="" />
          <div className={styles.rightText} onClick={() => getMerchantListQuestionDt(skillType)}>
            换一换
          </div>
        </div>
        <div className={styles.listBox}>
          {quickQuestions?.map(({ questionContent }, index) => {
            return (
              <div
                key={index}
                className={styles.listItem}
                onClick={() => {
                  onSubmit({ content: questionContent });
                }}
              >
                {questionContent || ''}
              </div>
            );
          })}
        </div>
      </div> */}
      {/* 猜你想问模块：第二版样式 */}
      <div className={styles.guessQuestionBox}>
        <div className={styles.guessQuestionList}>
          {quickQuestions?.map(({ questionContent, extend }, index) => {
            return (
              <div
                key={index}
                className={styles.listItem}
                onClick={() => {
                  onSubmit({ content: questionContent, extend });
                }}
              >
                <img src={questionIconMap[index]} alt="" />
                <span>{questionContent || ''}</span>
              </div>
            );
          })}
        </div>
        <div className={styles.changeQuestionBox} onClick={() => getMerchantListQuestionDt(skillType)}>
          <img src="https://imgcdn.sto.cn/01A8B7FB-5449-42-19x19-replace.png" alt="" />
          <span>换一换</span>
        </div>
      </div>
    </div>
  );
};

export default memo(Prologue);
